import { render, staticRenderFns } from "./treasureDialog.vue?vue&type=template&id=49e86c01"
import script from "./treasureDialog.vue?vue&type=script&lang=js"
export * from "./treasureDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports